import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

class DeleteButton extends React.Component {

  handleAxiosDelete = (fieldId, fieldURL, fieldToast, redirectWindowLocation) => {
    axios.delete(fieldURL + fieldId)
      .then(function (response) {
        toastr.error(fieldToast)
        setTimeout(function() { window.location.href = redirectWindowLocation != null ? redirectWindowLocation : fieldURL }.bind(this), 300)
      })
      .catch(function (error) {
        toastr.error('An error occured, please try again.')
        console.log(error)
      })
  }

  destroy = () => {
    if(!window.confirm(this.props.confirmMessage || 'Deleting this record is permanent'))
      return;

    this.handleAxiosDelete(this.props.fieldId, this.props.fieldURL, this.props.fieldToast, this.props.redirectURL || null);
  }

  render() {
    var that = this

    return(
      <button tabIndex={0} className={this.props.redirectURL ? 'btn btn-text pull-right' : 'btn btn-default btn-raised btn-long'}
          onClick={function(){that.destroy()}}>
         DELETE
      </button>
    )
  }
}

DeleteButton.propTypes = {
  fieldId: PropTypes.number,
  fieldURL: PropTypes.string,
  fieldToast: PropTypes.string,
  confirmMessage: PropTypes.string
}

export default DeleteButton
